// import pro from "../../images/competitions/pq1.jpg";
// import Webd from "../../images/competitions/webdev.jpg";
// import shark from "../../images/competitions/sharktank.jpeg";
// import hack from "../../images/competitions/hackk.jpg";
// import mdd from "../../images/competitions/mddd.jpg";
// import paperpe from "../../images/competitions/paperpres.png";
// import arud from "../../images/competitions/arduino.jpg";
// import enig from "../../images/competitions/enigmaa.jpg";
// import app from "../../images/competitions/appdev.jpg";
// import cad from "../../images/competitions/cad1.png";
// import circut from "../../images/competitions/circuit.jpg";
// import depp from "../../images/competitions/deepn.jpg";
export const mTechyData = [
    [
      
      {
        name: "Enigma",
        reglink: "https://dare2compete.com/competition/enigma-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273580",
        sublink: "https://forms.gle/YPDJXae6UJJhJK346",
        rules:
          "https://docs.google.com/document/d/1wzHGJylOVHgLyCJRqWtxTvXHdsSQmRS9vXzJYL_5YOw/edit#heading=h.b6dw3zk5atby",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/enigmaa-min_RylEjac2Ub.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598283108",
        details:
          "Find the mysterious secret techniques to decrypt the given texts/messages. Clear all the levels in the allotted time to become the ultimate cryptacker. It's a pen and paper event. Each team has to decode a series of crypted messages.",
      },
    ],
    [
      {
        name: "App Developement",
        reglink:
          "https://dare2compete.com/competition/app-development-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273590",
        sublink: "https://forms.gle/YyZAgE2VRCGzUTrE8",
        rules:
          "https://docs.google.com/document/d/1ie-VxbSXJKeCgXwReFTGrON45q6yJkiJgXBOpd4J-ls/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/appdev-min_6XCxRwjXv.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598280178",
        details:
          "This competition challenges participants to create innovative applications on mobile platforms - Android, iOS and Windows Phone. Grab the chance to Influence with creativity and innovation by designing a peculiar app.",
      },
    ],[
      {
        name: "Proquest",
        reglink: "https://dare2compete.com/hackathon/proquest-274160",
        sublink: "https://forms.gle/BL8zB7cgYiv1d6Mk8",
        rules:
          "https://docs.google.com/document/d/1AGet3_bye_f7wAeF0sRZg6ALPzB10HjhtUf4pqE1A4U/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/pq1-min_az6AxcNxx.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285971",
        details:
          "Experience the Competitive Programming Competition , for all participants of all levels of expertise. This event ensures that even an absolute beginner is able to solve something",
      },
    ],
    [
      {
        name: "Web Development",
        reglink:
          "https://dare2compete.com/competition/web-dev-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273400",
        sublink: "https://forms.gle/brEouAmZhbjghXwQA",
        rules:
          "https://docs.google.com/document/d/1xI7zxuOaYU_Zcnk3KNkzp0Aawwi9H1l8eKqIqtC1lg4/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/webdev-min_exlMpJ7YL.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598286903",
        details:
        "An event that empowers the creative and technically proficient future Web professionals.Participants can Innovate and Inspire by designing a creative Website in this competition."
    },
  ],[
      {
        name: "Shark Tank",
        reglink: "https://dare2compete.com/competition/shark-tank-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273354",
        sublink: "https://forms.gle/7o7Ur19UWNw5GhPJA",
        rules:
          "https://docs.google.com/document/d/1Y20CQekNwFNpwau_yT6YjKdtiQxQnBUUUvNhRR-r3ys/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/sharktank-min_mO3nNI71Q.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598286351",
        details:
          "Pitch is the first thing that is required by any entrepreneur. In this event participants have to pitch their ideas in front of a large audience in an online mode.",
      },
    ],[
      {
        name: "Circuit Building",
        reglink: "https://dare2compete.com/competition/circuit-building-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-272545",
        sublink: "https://forms.gle/9FoS6Bg5kiUt54nE7",
        rules:
          "https://docs.google.com/document/d/13lzjGhe8wtDXJMNlA6aiPhRAJ4vCR6fMo1UVQuJ-V0Q/edit#heading=h.3235yhsygykt",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/circuit_OVCy9oy1C.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647599736000",
        details:
          "The aim of this competition is to judge the problem solving skills and understanding of the basic circuit designing concepts of the students. Each team has to build a circuit as per the requirement keeping in mind the efficiency factor.",
      },
    ],
    [
      {
        name: "Code Arduino",
        reglink: "https://dare2compete.com/hackathon/code-arduino-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273568",
        sublink: "https://forms.gle/8T9GwzxzdqSSu98P7",
        rules:
          "https://docs.google.com/document/d/1ZDsGh_YZHdFvkI4qK2g-gUwfibrUwKd5PLvisbOOj20/edit#heading=h.3235yhsygykt",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/arduino-min_WsbX4dW4u.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598280670",
        details:
          "The competition aims to test the knowledge of participants on Arduino IDE.",
      },
    ],[
      {
        name: "Machina Doctrina",
        reglink:
          "https://dare2compete.com/hackathon/machina-doctrinas-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273585",
        sublink: "https://forms.gle/fyyrHb4E9MQh5Rmf6",
        rules:
          "https://docs.google.com/document/d/17bkoRtcd99baTlUBkFts6MF1GYxZYOR1q4tN4NHtS3Y/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/mddd-min_cxvtNpRKB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598284627",
        details:
          "If making machines learn is your forté, this is the perfect event for you. Test and hone your skills in ML and Data Analytics by participating in Machina doctrinas, one of the coolest events in the fest!.",
      },
    ],[
      {
        name: "DeepN",
        reglink: "https://dare2compete.com/hackathon/deepn-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273589",
        sublink: "https://forms.gle/bMcrbbZ2MWc4xrE9A",
        rules:
          "https://docs.google.com/document/d/1nMJd8YV4yNsFr0sS9IOW893k_TfFb8fGWfsRnGDGaRY/edit",
        img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/deepn_SxCZWSg7X.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647599862082",
        details: "If Technology had a face now, it would be ‘AI’. An on-spot challenge that would test your understanding of Deep Learning.",
      },
    ],
    [
        {
          name: "CAD PRO",
          reglink: "https://dare2compete.com/competition/cad-pro-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273588",
          sublink: "https://forms.gle/8T9GwzxzdqSSu98P7",
          rules:
            "https://docs.google.com/document/d/1yPmSpc-j63HQRnJHIozlBusZvOL_7gOPc4C2eoDhYYs/edit#heading=h.j2sk9juhxzeu",
          img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/cad1-min_ftoFAJm6f.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647598281955",
          details:
            "Contrive a way to outsmart your opponents in designing a CAD model.An on-the-spot designing round to show off your expertise in designing.",
        },
      ],[
        {
          name: "Hackathon",
          reglink:
            "https://dare2compete.com/hackathon/hackathon-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-272342",
          sublink: "https://forms.gle/fyyrHb4E9MQh5Rmf6",
          rules:
            "https://docs.google.com/document/d/14xp2tSHajqrY-i9RYA3ZKYcLm2yJnLEZMCTBXbZz_G8/edit",
          img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/hackk-min_UbJVASgpUe.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598284333",
          details:
            "A unique hackathon on emerging digital technologies to engage with tech enthusiasts. It offers an array of challenges across multiple levels.",
        },
      ],[
        {
          name: "Paper Presentation",
          reglink: "https://dare2compete.com/competition/paper-presentation-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-272356",
          sublink: "https://forms.gle/bMcrbbZ2MWc4xrE9A",
          rules:
            "https://docs.google.com/document/d/1EN1j2047opvegnPWvpc948hF6BheRCR77HRnf9lSbO8/edit",
          img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/paperpres-min_LdkSwsc0l.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285351",
          details: "In this event, contestants prepare a presentation that showcases and effectively presents new ideas related to any field or even an entire business plan. The main idea of the event is to analyze a topic and think with a new bent of mind.",
        },
      ],
      [
        {
          name: "Game Jam",
          reglink: "https://dare2compete.com/competition/game-jam-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-273560",
          sublink: "https://forms.gle/bMcrbbZ2MWc4xrE9A",
          rules:
            "https://docs.google.com/document/d/1yb1K_strRj-p4t3xCVlGbWIl5G2PDZIKjABQq1u7YFo/edit",
          img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/paperpres-min_LdkSwsc0l.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285351",
          details: "Developing a game is the new meta. Game Jam is an event that enables one to create a game from scratch and within the time barrier.",
        }
      ]
  ];
  
